import * as m from "react";
import { useLayoutEffect as bn } from "react";
import { jsxs as yn, Fragment as Yn, jsx as ge } from "react/jsx-runtime";
import * as wn from "react-dom";
function ot() {
  return typeof window < "u";
}
function Ce(e) {
  return It(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ee(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ue(e) {
  var t;
  return (t = (It(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function It(e) {
  return ot() ? e instanceof Node || e instanceof ee(e).Node : !1;
}
function H(e) {
  return ot() ? e instanceof Element || e instanceof ee(e).Element : !1;
}
function U(e) {
  return ot() ? e instanceof HTMLElement || e instanceof ee(e).HTMLElement : !1;
}
function Ct(e) {
  return !ot() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ee(e).ShadowRoot;
}
function We(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = se(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function zn(e) {
  return /^(table|td|th)$/.test(Ce(e));
}
function it(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Gn = /transform|translate|scale|rotate|perspective|filter/, Zn = /paint|layout|strict|content/, Se = (e) => !!e && e !== "none";
let gt;
function kt(e) {
  const t = H(e) ? se(e) : e;
  return Se(t.transform) || Se(t.translate) || Se(t.scale) || Se(t.rotate) || Se(t.perspective) || !st() && (Se(t.backdropFilter) || Se(t.filter)) || Gn.test(t.willChange || "") || Zn.test(t.contain || "");
}
function Jn(e) {
  let t = ve(e);
  for (; U(t) && !pe(t); ) {
    if (kt(t))
      return t;
    if (it(t))
      return null;
    t = ve(t);
  }
  return null;
}
function st() {
  return gt == null && (gt = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), gt;
}
function pe(e) {
  return /^(html|body|#document)$/.test(Ce(e));
}
function se(e) {
  return ee(e).getComputedStyle(e);
}
function ct(e) {
  return H(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ve(e) {
  if (Ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ct(e) && e.host || // Fallback.
    ue(e)
  );
  return Ct(t) ? t.host : t;
}
function Rn(e) {
  const t = ve(e);
  return pe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : U(t) && We(t) ? t : Rn(t);
}
function xe(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Rn(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = ee(o);
  if (i) {
    const c = Tt(s);
    return t.concat(s, s.visualViewport || [], We(o) ? o : [], c && n ? xe(c) : []);
  } else
    return t.concat(o, xe(o, [], n));
}
function Tt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const De = Math.min, re = Math.max, ze = Math.round, qe = Math.floor, le = (e) => ({
  x: e,
  y: e
}), Qn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Vt(e, t, n) {
  return re(e, De(t, n));
}
function $e(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ee(e) {
  return e.split("-")[0];
}
function Be(e) {
  return e.split("-")[1];
}
function xn(e) {
  return e === "x" ? "y" : "x";
}
function En(e) {
  return e === "y" ? "height" : "width";
}
function me(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Cn(e) {
  return xn(me(e));
}
function er(e, t, n) {
  n === void 0 && (n = !1);
  const r = Be(e), o = Cn(e), i = En(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Ge(s)), [s, Ge(s)];
}
function tr(e) {
  const t = Ge(e);
  return [St(e), t, St(t)];
}
function St(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Ht = ["left", "right"], Kt = ["right", "left"], nr = ["top", "bottom"], rr = ["bottom", "top"];
function or(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Kt : Ht : t ? Ht : Kt;
    case "left":
    case "right":
      return t ? nr : rr;
    default:
      return [];
  }
}
function ir(e, t, n, r) {
  const o = Be(e);
  let i = or(Ee(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(St)))), i;
}
function Ge(e) {
  const t = Ee(e);
  return Qn[t] + e.slice(t.length);
}
function sr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function cr(e) {
  return typeof e != "number" ? sr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ze(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var lr = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Je = /* @__PURE__ */ lr.join(","), Tn = typeof Element > "u", Fe = Tn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Qe = !Tn && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, et = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", s = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : et(t.parentNode));
  return s;
}, ur = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Sn = function(t, n, r) {
  if (et(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Je));
  return n && Fe.call(t, Je) && o.unshift(t), o = o.filter(r), o;
}, tt = function(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (!et(s, !1))
      if (s.tagName === "SLOT") {
        var c = s.assignedElements(), u = c.length ? c : s.children, l = tt(u, !0, r);
        r.flatten ? o.push.apply(o, l) : o.push({
          scopeParent: s,
          candidates: l
        });
      } else {
        var f = Fe.call(s, Je);
        f && r.filter(s) && (n || !t.includes(s)) && o.push(s);
        var g = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), v = !et(g, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (g && v) {
          var a = tt(g === !0 ? s.children : g.children, !0, r);
          r.flatten ? o.push.apply(o, a) : o.push({
            scopeParent: s,
            candidates: a
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, An = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, On = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || ur(t)) && !An(t) ? 0 : t.tabIndex;
}, ar = function(t, n) {
  var r = On(t);
  return r < 0 && n && !An(t) ? 0 : r;
}, fr = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Mn = function(t) {
  return t.tagName === "INPUT";
}, dr = function(t) {
  return Mn(t) && t.type === "hidden";
}, mr = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, gr = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, pr = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Qe(t), r = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = gr(o, t.form);
  return !i || i === t;
}, vr = function(t) {
  return Mn(t) && t.type === "radio";
}, hr = function(t) {
  return vr(t) && !pr(t);
}, br = function(t) {
  var n, r = t && Qe(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var s, c, u;
    for (i = !!((s = o) !== null && s !== void 0 && (c = s.ownerDocument) !== null && c !== void 0 && c.contains(o) || t != null && (u = t.ownerDocument) !== null && u !== void 0 && u.contains(t)); !i && o; ) {
      var l, f, g;
      r = Qe(o), o = (l = r) === null || l === void 0 ? void 0 : l.host, i = !!((f = o) !== null && f !== void 0 && (g = f.ownerDocument) !== null && g !== void 0 && g.contains(o));
    }
  }
  return i;
}, qt = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, yr = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = Fe.call(t, "details>summary:first-of-type"), c = s ? t.parentElement : t;
  if (Fe.call(c, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var u = t; t; ) {
        var l = t.parentElement, f = Qe(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return qt(t);
        t.assignedSlot ? t = t.assignedSlot : !l && f !== t.ownerDocument ? t = f.host : t = l;
      }
      t = u;
    }
    if (br(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return qt(t);
  return !1;
}, wr = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Fe.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, At = function(t, n) {
  return !(n.disabled || dr(n) || yr(n, t) || // For a details element with a summary, the summary element gets the focus
  mr(n) || wr(n));
}, Ot = function(t, n) {
  return !(hr(n) || On(n) < 0 || !At(t, n));
}, Rr = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ln = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var s = !!o.scopeParent, c = s ? o.scopeParent : o, u = ar(c, s), l = s ? Ln(o.candidates) : c;
    u === 0 ? s ? n.push.apply(n, l) : n.push(c) : r.push({
      documentOrder: i,
      tabIndex: u,
      item: o,
      isScope: s,
      content: l
    });
  }), r.sort(fr).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, lt = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = tt([t], n.includeContainer, {
    filter: Ot.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Rr
  }) : r = Sn(t, n.includeContainer, Ot.bind(null, n)), Ln(r);
}, xr = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = tt([t], n.includeContainer, {
    filter: At.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Sn(t, n.includeContainer, At.bind(null, n)), r;
}, Pn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Fe.call(t, Je) === !1 ? !1 : Ot(n, t);
};
function Dt() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function In() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function kn() {
  return /apple/i.test(navigator.vendor);
}
function Mt() {
  const e = /android/i;
  return e.test(Dt()) || e.test(In());
}
function Er() {
  return Dt().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Dn() {
  return In().includes("jsdom/");
}
const jt = "data-floating-ui-focusable", Cr = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function we(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function G(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ct(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function de(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function pt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Tr(e) {
  return e.matches("html,body");
}
function Z(e) {
  return e?.ownerDocument || document;
}
function Ft(e) {
  return U(e) && e.matches(Cr);
}
function Xt(e) {
  return e ? e.getAttribute("role") === "combobox" && Ft(e) : !1;
}
function Sr(e) {
  if (!e || Dn()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Lt(e) {
  return e ? e.hasAttribute(jt) ? e : e.querySelector("[" + jt + "]") || e : null;
}
function Pe(e, t, n) {
  return n === void 0 && (n = !0), e.filter((o) => {
    var i;
    return o.parentId === t && (!n || ((i = o.context) == null ? void 0 : i.open));
  }).flatMap((o) => [o, ...Pe(e, o.id, n)]);
}
function Ut(e, t) {
  var n;
  let r = [], o = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const i = e.find((s) => s.id === o);
    o = i?.parentId, i && (r = r.concat(i));
  }
  return r;
}
function vt(e) {
  e.preventDefault(), e.stopPropagation();
}
function Ar(e) {
  return "nativeEvent" in e;
}
function Or(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Mt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Mr(e) {
  return Dn() ? !1 : !Mt() && e.width === 0 && e.height === 0 || Mt() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function _e(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
var Lr = typeof document < "u", Pr = function() {
}, J = Lr ? bn : Pr;
const Ir = {
  ...m
};
function Ae(e) {
  const t = m.useRef(e);
  return J(() => {
    t.current = e;
  }), t;
}
const kr = Ir.useInsertionEffect, Dr = kr || ((e) => e());
function Q(e) {
  const t = m.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Dr(() => {
    t.current = e;
  }), m.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const Ve = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function Fn(e, t) {
  const n = lt(e, Ve()), r = n.length;
  if (r === 0) return;
  const o = we(Z(e)), i = n.indexOf(o), s = i === -1 ? t === 1 ? 0 : r - 1 : i + t;
  return n[s];
}
function Nn(e) {
  return Fn(Z(e).body, 1) || e;
}
function _n(e) {
  return Fn(Z(e).body, -1) || e;
}
function Ne(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !G(n, r);
}
function Fr(e) {
  lt(e, Ve()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Yt(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function zt(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = me(t), s = Cn(t), c = En(s), u = Ee(t), l = i === "y", f = r.x + r.width / 2 - o.width / 2, g = r.y + r.height / 2 - o.height / 2, v = r[c] / 2 - o[c] / 2;
  let a;
  switch (u) {
    case "top":
      a = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      a = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      a = {
        x: r.x + r.width,
        y: g
      };
      break;
    case "left":
      a = {
        x: r.x - o.width,
        y: g
      };
      break;
    default:
      a = {
        x: r.x,
        y: r.y
      };
  }
  switch (Be(t)) {
    case "start":
      a[s] -= v * (n && l ? -1 : 1);
      break;
    case "end":
      a[s] += v * (n && l ? -1 : 1);
      break;
  }
  return a;
}
async function Nr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: g = "floating",
    altBoundary: v = !1,
    padding: a = 0
  } = $e(t, e), p = cr(a), R = c[v ? g === "floating" ? "reference" : "floating" : g], w = Ze(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(R))) == null || n ? R : R.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: u
  })), b = g === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), C = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = Ze(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: b,
    offsetParent: y,
    strategy: u
  }) : b);
  return {
    top: (w.top - O.top + p.top) / C.y,
    bottom: (O.bottom - w.bottom + p.bottom) / C.y,
    left: (w.left - O.left + p.left) / C.x,
    right: (O.right - w.right + p.right) / C.x
  };
}
const _r = 50, Wr = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = s.detectOverflow ? s : {
    ...s,
    detectOverflow: Nr
  }, u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: g
  } = zt(l, r, u), v = r, a = 0;
  const p = {};
  for (let d = 0; d < i.length; d++) {
    const R = i[d];
    if (!R)
      continue;
    const {
      name: w,
      fn: b
    } = R, {
      x: y,
      y: C,
      data: O,
      reset: M
    } = await b({
      x: f,
      y: g,
      initialPlacement: r,
      placement: v,
      strategy: o,
      middlewareData: p,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = y ?? f, g = C ?? g, p[w] = {
      ...p[w],
      ...O
    }, M && a < _r && (a++, typeof M == "object" && (M.placement && (v = M.placement), M.rects && (l = M.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : M.rects), {
      x: f,
      y: g
    } = zt(l, v, u)), d = -1);
  }
  return {
    x: f,
    y: g,
    placement: v,
    strategy: o,
    middlewareData: p
  };
}, $r = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: u,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: g = !0,
        fallbackPlacements: v,
        fallbackStrategy: a = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: d = !0,
        ...R
      } = $e(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const w = Ee(o), b = me(c), y = Ee(c) === c, C = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), O = v || (y || !d ? [Ge(c)] : tr(c)), M = p !== "none";
      !v && M && O.push(...ir(c, d, p, C));
      const I = [c, ...O], W = await u.detectOverflow(t, R), q = [];
      let $ = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && q.push(W[w]), g) {
        const x = er(o, s, C);
        q.push(W[x[0]], W[x[1]]);
      }
      if ($ = [...$, {
        placement: o,
        overflows: q
      }], !q.every((x) => x <= 0)) {
        var _, X;
        const x = (((_ = i.flip) == null ? void 0 : _.index) || 0) + 1, E = I[x];
        if (E && (!(g === "alignment" ? b !== me(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        $.every((h) => me(h.placement) === b ? h.overflows[0] > 0 : !0)))
          return {
            data: {
              index: x,
              overflows: $
            },
            reset: {
              placement: E
            }
          };
        let F = (X = $.filter((T) => T.overflows[0] <= 0).sort((T, h) => T.overflows[1] - h.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!F)
          switch (a) {
            case "bestFit": {
              var B;
              const T = (B = $.filter((h) => {
                if (M) {
                  const S = me(h.placement);
                  return S === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  S === "y";
                }
                return !0;
              }).map((h) => [h.placement, h.overflows.filter((S) => S > 0).reduce((S, L) => S + L, 0)]).sort((h, S) => h[1] - S[1])[0]) == null ? void 0 : B[0];
              T && (F = T);
              break;
            }
            case "initialPlacement":
              F = c;
              break;
          }
        if (o !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
}, Br = /* @__PURE__ */ new Set(["left", "top"]);
async function Vr(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Ee(n), c = Be(n), u = me(n) === "y", l = Br.has(s) ? -1 : 1, f = i && u ? -1 : 1, g = $e(t, e);
  let {
    mainAxis: v,
    crossAxis: a,
    alignmentAxis: p
  } = typeof g == "number" ? {
    mainAxis: g,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: g.mainAxis || 0,
    crossAxis: g.crossAxis || 0,
    alignmentAxis: g.alignmentAxis
  };
  return c && typeof p == "number" && (a = c === "end" ? p * -1 : p), u ? {
    x: a * f,
    y: v * l
  } : {
    x: v * l,
    y: a * f
  };
}
const Hr = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, u = await Vr(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Kr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: i
      } = t, {
        mainAxis: s = !0,
        crossAxis: c = !1,
        limiter: u = {
          fn: (w) => {
            let {
              x: b,
              y
            } = w;
            return {
              x: b,
              y
            };
          }
        },
        ...l
      } = $e(e, t), f = {
        x: n,
        y: r
      }, g = await i.detectOverflow(t, l), v = me(Ee(o)), a = xn(v);
      let p = f[a], d = f[v];
      if (s) {
        const w = a === "y" ? "top" : "left", b = a === "y" ? "bottom" : "right", y = p + g[w], C = p - g[b];
        p = Vt(y, p, C);
      }
      if (c) {
        const w = v === "y" ? "top" : "left", b = v === "y" ? "bottom" : "right", y = d + g[w], C = d - g[b];
        d = Vt(y, d, C);
      }
      const R = u.fn({
        ...t,
        [a]: p,
        [v]: d
      });
      return {
        ...R,
        data: {
          x: R.x - n,
          y: R.y - r,
          enabled: {
            [a]: s,
            [v]: c
          }
        }
      };
    }
  };
}, qr = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: u = () => {
        },
        ...l
      } = $e(e, t), f = await s.detectOverflow(t, l), g = Ee(o), v = Be(o), a = me(o) === "y", {
        width: p,
        height: d
      } = i.floating;
      let R, w;
      g === "top" || g === "bottom" ? (R = g, w = v === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (w = g, R = v === "end" ? "top" : "bottom");
      const b = d - f.top - f.bottom, y = p - f.left - f.right, C = De(d - f[R], b), O = De(p - f[w], y), M = !t.middlewareData.shift;
      let I = C, W = O;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (W = y), (r = t.middlewareData.shift) != null && r.enabled.y && (I = b), M && !v) {
        const $ = re(f.left, 0), _ = re(f.right, 0), X = re(f.top, 0), B = re(f.bottom, 0);
        a ? W = p - 2 * ($ !== 0 || _ !== 0 ? $ + _ : re(f.left, f.right)) : I = d - 2 * (X !== 0 || B !== 0 ? X + B : re(f.top, f.bottom));
      }
      await u({
        ...t,
        availableWidth: W,
        availableHeight: I
      });
      const q = await s.getDimensions(c.floating);
      return p !== q.width || d !== q.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Wn(e) {
  const t = se(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = U(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, c = ze(n) !== i || ze(r) !== s;
  return c && (n = i, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function Nt(e) {
  return H(e) ? e : e.contextElement;
}
function Ie(e) {
  const t = Nt(e);
  if (!U(t))
    return le(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Wn(t);
  let s = (i ? ze(n.width) : n.width) / r, c = (i ? ze(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const jr = /* @__PURE__ */ le(0);
function $n(e) {
  const t = ee(e);
  return !st() || !t.visualViewport ? jr : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Xr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ee(e) ? !1 : t;
}
function Oe(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Nt(e);
  let s = le(1);
  t && (r ? H(r) && (s = Ie(r)) : s = Ie(e));
  const c = Xr(i, n, r) ? $n(i) : le(0);
  let u = (o.left + c.x) / s.x, l = (o.top + c.y) / s.y, f = o.width / s.x, g = o.height / s.y;
  if (i) {
    const v = ee(i), a = r && H(r) ? ee(r) : r;
    let p = v, d = Tt(p);
    for (; d && r && a !== p; ) {
      const R = Ie(d), w = d.getBoundingClientRect(), b = se(d), y = w.left + (d.clientLeft + parseFloat(b.paddingLeft)) * R.x, C = w.top + (d.clientTop + parseFloat(b.paddingTop)) * R.y;
      u *= R.x, l *= R.y, f *= R.x, g *= R.y, u += y, l += C, p = ee(d), d = Tt(p);
    }
  }
  return Ze({
    width: f,
    height: g,
    x: u,
    y: l
  });
}
function ut(e, t) {
  const n = ct(e).scrollLeft;
  return t ? t.left + n : Oe(ue(e)).left + n;
}
function Bn(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - ut(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Ur(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = ue(r), c = t ? it(t.floating) : !1;
  if (r === s || c && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = le(1);
  const f = le(0), g = U(r);
  if ((g || !g && !i) && ((Ce(r) !== "body" || We(s)) && (u = ct(r)), g)) {
    const a = Oe(r);
    l = Ie(r), f.x = a.x + r.clientLeft, f.y = a.y + r.clientTop;
  }
  const v = s && !g && !i ? Bn(s, u) : le(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + f.x + v.x,
    y: n.y * l.y - u.scrollTop * l.y + f.y + v.y
  };
}
function Yr(e) {
  return Array.from(e.getClientRects());
}
function zr(e) {
  const t = ue(e), n = ct(e), r = e.ownerDocument.body, o = re(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = re(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + ut(e);
  const c = -n.scrollTop;
  return se(r).direction === "rtl" && (s += re(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
const Gt = 25;
function Gr(e, t) {
  const n = ee(e), r = ue(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, c = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    const f = st();
    (!f || f && t === "fixed") && (c = o.offsetLeft, u = o.offsetTop);
  }
  const l = ut(r);
  if (l <= 0) {
    const f = r.ownerDocument, g = f.body, v = getComputedStyle(g), a = f.compatMode === "CSS1Compat" && parseFloat(v.marginLeft) + parseFloat(v.marginRight) || 0, p = Math.abs(r.clientWidth - g.clientWidth - a);
    p <= Gt && (i -= p);
  } else l <= Gt && (i += l);
  return {
    width: i,
    height: s,
    x: c,
    y: u
  };
}
function Zr(e, t) {
  const n = Oe(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = U(e) ? Ie(e) : le(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, u = o * i.x, l = r * i.y;
  return {
    width: s,
    height: c,
    x: u,
    y: l
  };
}
function Zt(e, t, n) {
  let r;
  if (t === "viewport")
    r = Gr(e, n);
  else if (t === "document")
    r = zr(ue(e));
  else if (H(t))
    r = Zr(t, n);
  else {
    const o = $n(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ze(r);
}
function Vn(e, t) {
  const n = ve(e);
  return n === t || !H(n) || pe(n) ? !1 : se(n).position === "fixed" || Vn(n, t);
}
function Jr(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = xe(e, [], !1).filter((c) => H(c) && Ce(c) !== "body"), o = null;
  const i = se(e).position === "fixed";
  let s = i ? ve(e) : e;
  for (; H(s) && !pe(s); ) {
    const c = se(s), u = kt(s);
    !u && c.position === "fixed" && (o = null), (i ? !u && !o : !u && c.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || We(s) && !u && Vn(e, s)) ? r = r.filter((f) => f !== s) : o = c, s = ve(s);
  }
  return t.set(e, r), r;
}
function Qr(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? it(t) ? [] : Jr(t, this._c) : [].concat(n), r], c = Zt(t, s[0], o);
  let u = c.top, l = c.right, f = c.bottom, g = c.left;
  for (let v = 1; v < s.length; v++) {
    const a = Zt(t, s[v], o);
    u = re(a.top, u), l = De(a.right, l), f = De(a.bottom, f), g = re(a.left, g);
  }
  return {
    width: l - g,
    height: f - u,
    x: g,
    y: u
  };
}
function eo(e) {
  const {
    width: t,
    height: n
  } = Wn(e);
  return {
    width: t,
    height: n
  };
}
function to(e, t, n) {
  const r = U(t), o = ue(t), i = n === "fixed", s = Oe(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = le(0);
  function l() {
    u.x = ut(o);
  }
  if (r || !r && !i)
    if ((Ce(t) !== "body" || We(o)) && (c = ct(t)), r) {
      const a = Oe(t, !0, i, t);
      u.x = a.x + t.clientLeft, u.y = a.y + t.clientTop;
    } else o && l();
  i && !r && o && l();
  const f = o && !r && !i ? Bn(o, c) : le(0), g = s.left + c.scrollLeft - u.x - f.x, v = s.top + c.scrollTop - u.y - f.y;
  return {
    x: g,
    y: v,
    width: s.width,
    height: s.height
  };
}
function ht(e) {
  return se(e).position === "static";
}
function Jt(e, t) {
  if (!U(e) || se(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ue(e) === n && (n = n.ownerDocument.body), n;
}
function Hn(e, t) {
  const n = ee(e);
  if (it(e))
    return n;
  if (!U(e)) {
    let o = ve(e);
    for (; o && !pe(o); ) {
      if (H(o) && !ht(o))
        return o;
      o = ve(o);
    }
    return n;
  }
  let r = Jt(e, t);
  for (; r && zn(r) && ht(r); )
    r = Jt(r, t);
  return r && pe(r) && ht(r) && !kt(r) ? n : r || Jn(e) || n;
}
const no = async function(e) {
  const t = this.getOffsetParent || Hn, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: to(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ro(e) {
  return se(e).direction === "rtl";
}
const oo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ur,
  getDocumentElement: ue,
  getClippingRect: Qr,
  getOffsetParent: Hn,
  getElementRects: no,
  getClientRects: Yr,
  getDimensions: eo,
  getScale: Ie,
  isElement: H,
  isRTL: ro
};
function Kn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function io(e, t) {
  let n = null, r;
  const o = ue(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), i();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: g,
      width: v,
      height: a
    } = l;
    if (c || t(), !v || !a)
      return;
    const p = qe(g), d = qe(o.clientWidth - (f + v)), R = qe(o.clientHeight - (g + a)), w = qe(f), y = {
      rootMargin: -p + "px " + -d + "px " + -R + "px " + -w + "px",
      threshold: re(0, De(1, u)) || 1
    };
    let C = !0;
    function O(M) {
      const I = M[0].intersectionRatio;
      if (I !== u) {
        if (!C)
          return s();
        I ? s(!1, I) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !Kn(l, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, y);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Vo(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Nt(e), f = o || i ? [...l ? xe(l) : [], ...t ? xe(t) : []] : [];
  f.forEach((w) => {
    o && w.addEventListener("scroll", n, {
      passive: !0
    }), i && w.addEventListener("resize", n);
  });
  const g = l && c ? io(l, n) : null;
  let v = -1, a = null;
  s && (a = new ResizeObserver((w) => {
    let [b] = w;
    b && b.target === l && a && t && (a.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var y;
      (y = a) == null || y.observe(t);
    })), n();
  }), l && !u && a.observe(l), t && a.observe(t));
  let p, d = u ? Oe(e) : null;
  u && R();
  function R() {
    const w = Oe(e);
    d && !Kn(d, w) && n(), d = w, p = requestAnimationFrame(R);
  }
  return n(), () => {
    var w;
    f.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), g?.(), (w = a) == null || w.disconnect(), a = null, u && cancelAnimationFrame(p);
  };
}
const so = Hr, co = Kr, lo = $r, uo = qr, ao = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: oo,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Wr(e, t, {
    ...o,
    platform: i
  });
};
var fo = typeof document < "u", mo = function() {
}, Ye = fo ? bn : mo;
function nt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!nt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !nt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function qn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Qt(e, t) {
  const n = qn(e);
  return Math.round(t * n) / n;
}
function bt(e) {
  const t = m.useRef(e);
  return Ye(() => {
    t.current = e;
  }), t;
}
function go(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: u,
    open: l
  } = e, [f, g] = m.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [v, a] = m.useState(r);
  nt(v, r) || a(r);
  const [p, d] = m.useState(null), [R, w] = m.useState(null), b = m.useCallback((h) => {
    h !== M.current && (M.current = h, d(h));
  }, []), y = m.useCallback((h) => {
    h !== I.current && (I.current = h, w(h));
  }, []), C = i || p, O = s || R, M = m.useRef(null), I = m.useRef(null), W = m.useRef(f), q = u != null, $ = bt(u), _ = bt(o), X = bt(l), B = m.useCallback(() => {
    if (!M.current || !I.current)
      return;
    const h = {
      placement: t,
      strategy: n,
      middleware: v
    };
    _.current && (h.platform = _.current), ao(M.current, I.current, h).then((S) => {
      const L = {
        ...S,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: X.current !== !1
      };
      x.current && !nt(W.current, L) && (W.current = L, wn.flushSync(() => {
        g(L);
      }));
    });
  }, [v, t, n, _, X]);
  Ye(() => {
    l === !1 && W.current.isPositioned && (W.current.isPositioned = !1, g((h) => ({
      ...h,
      isPositioned: !1
    })));
  }, [l]);
  const x = m.useRef(!1);
  Ye(() => (x.current = !0, () => {
    x.current = !1;
  }), []), Ye(() => {
    if (C && (M.current = C), O && (I.current = O), C && O) {
      if ($.current)
        return $.current(C, O, B);
      B();
    }
  }, [C, O, B, $, q]);
  const E = m.useMemo(() => ({
    reference: M,
    floating: I,
    setReference: b,
    setFloating: y
  }), [b, y]), F = m.useMemo(() => ({
    reference: C,
    floating: O
  }), [C, O]), T = m.useMemo(() => {
    const h = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return h;
    const S = Qt(F.floating, f.x), L = Qt(F.floating, f.y);
    return c ? {
      ...h,
      transform: "translate(" + S + "px, " + L + "px)",
      ...qn(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: S,
      top: L
    };
  }, [n, c, F.floating, f.x, f.y]);
  return m.useMemo(() => ({
    ...f,
    update: B,
    refs: E,
    elements: F,
    floatingStyles: T
  }), [f, B, E, F, T]);
}
const Ho = (e, t) => {
  const n = so(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ko = (e, t) => {
  const n = co(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, qo = (e, t) => {
  const n = lo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, jo = (e, t) => {
  const n = uo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
function Xo(e) {
  const t = m.useRef(void 0), n = m.useCallback((r) => {
    const o = e.map((i) => {
      if (i != null) {
        if (typeof i == "function") {
          const s = i, c = s(r);
          return typeof c == "function" ? c : () => {
            s(null);
          };
        }
        return i.current = r, () => {
          i.current = null;
        };
      }
    });
    return () => {
      o.forEach((i) => i?.());
    };
  }, e);
  return m.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const po = "data-floating-ui-focusable", en = "active", tn = "selected", vo = {
  ...m
};
let nn = !1, ho = 0;
const rn = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ho++
);
function bo() {
  const [e, t] = m.useState(() => nn ? rn() : void 0);
  return J(() => {
    e == null && t(rn());
  }, []), m.useEffect(() => {
    nn = !0;
  }, []), e;
}
const yo = vo.useId, _t = yo || bo;
let Pt;
process.env.NODE_ENV !== "production" && (Pt = /* @__PURE__ */ new Set());
function wo() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Pt) != null && e.has(o))) {
    var i;
    (i = Pt) == null || i.add(o), console.error(o);
  }
}
function Ro() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
const xo = /* @__PURE__ */ m.createContext(null), Eo = /* @__PURE__ */ m.createContext(null), Wt = () => {
  var e;
  return ((e = m.useContext(xo)) == null ? void 0 : e.id) || null;
}, at = () => m.useContext(Eo);
function Me(e) {
  return "data-floating-ui-" + e;
}
function ne(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
const on = /* @__PURE__ */ Me("safe-polygon");
function yt(e, t, n) {
  if (n && !_e(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const r = e();
    return typeof r == "number" ? r : r?.[t];
  }
  return e?.[t];
}
function wt(e) {
  return typeof e == "function" ? e() : e;
}
function Uo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: s
  } = e, {
    enabled: c = !0,
    delay: u = 0,
    handleClose: l = null,
    mouseOnly: f = !1,
    restMs: g = 0,
    move: v = !0
  } = t, a = at(), p = Wt(), d = Ae(l), R = Ae(u), w = Ae(n), b = Ae(g), y = m.useRef(), C = m.useRef(-1), O = m.useRef(), M = m.useRef(-1), I = m.useRef(!0), W = m.useRef(!1), q = m.useRef(() => {
  }), $ = m.useRef(!1), _ = Q(() => {
    var T;
    const h = (T = o.current.openEvent) == null ? void 0 : T.type;
    return h?.includes("mouse") && h !== "mousedown";
  });
  m.useEffect(() => {
    if (!c) return;
    function T(h) {
      let {
        open: S
      } = h;
      S || (ne(C), ne(M), I.current = !0, $.current = !1);
    }
    return i.on("openchange", T), () => {
      i.off("openchange", T);
    };
  }, [c, i]), m.useEffect(() => {
    if (!c || !d.current || !n) return;
    function T(S) {
      _() && r(!1, S, "hover");
    }
    const h = Z(s.floating).documentElement;
    return h.addEventListener("mouseleave", T), () => {
      h.removeEventListener("mouseleave", T);
    };
  }, [s.floating, n, r, c, d, _]);
  const X = m.useCallback(function(T, h, S) {
    h === void 0 && (h = !0), S === void 0 && (S = "hover");
    const L = yt(R.current, "close", y.current);
    L && !O.current ? (ne(C), C.current = window.setTimeout(() => r(!1, T, S), L)) : h && (ne(C), r(!1, T, S));
  }, [R, r]), B = Q(() => {
    q.current(), O.current = void 0;
  }), x = Q(() => {
    if (W.current) {
      const T = Z(s.floating).body;
      T.style.pointerEvents = "", T.removeAttribute(on), W.current = !1;
    }
  }), E = Q(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  m.useEffect(() => {
    if (!c) return;
    function T(k) {
      if (ne(C), I.current = !1, f && !_e(y.current) || wt(b.current) > 0 && !yt(R.current, "open"))
        return;
      const A = yt(R.current, "open", y.current);
      A ? C.current = window.setTimeout(() => {
        w.current || r(!0, k, "hover");
      }, A) : n || r(!0, k, "hover");
    }
    function h(k) {
      if (E()) {
        x();
        return;
      }
      q.current();
      const A = Z(s.floating);
      if (ne(M), $.current = !1, d.current && o.current.floatingContext) {
        n || ne(C), O.current = d.current({
          ...o.current.floatingContext,
          tree: a,
          x: k.clientX,
          y: k.clientY,
          onClose() {
            x(), B(), E() || X(k, !0, "safe-polygon");
          }
        });
        const K = O.current;
        A.addEventListener("mousemove", K), q.current = () => {
          A.removeEventListener("mousemove", K);
        };
        return;
      }
      (y.current === "touch" ? !G(s.floating, k.relatedTarget) : !0) && X(k);
    }
    function S(k) {
      E() || o.current.floatingContext && (d.current == null || d.current({
        ...o.current.floatingContext,
        tree: a,
        x: k.clientX,
        y: k.clientY,
        onClose() {
          x(), B(), E() || X(k);
        }
      })(k));
    }
    function L() {
      ne(C);
    }
    function Y(k) {
      E() || X(k, !1);
    }
    if (H(s.domReference)) {
      const k = s.domReference, A = s.floating;
      return n && k.addEventListener("mouseleave", S), v && k.addEventListener("mousemove", T, {
        once: !0
      }), k.addEventListener("mouseenter", T), k.addEventListener("mouseleave", h), A && (A.addEventListener("mouseleave", S), A.addEventListener("mouseenter", L), A.addEventListener("mouseleave", Y)), () => {
        n && k.removeEventListener("mouseleave", S), v && k.removeEventListener("mousemove", T), k.removeEventListener("mouseenter", T), k.removeEventListener("mouseleave", h), A && (A.removeEventListener("mouseleave", S), A.removeEventListener("mouseenter", L), A.removeEventListener("mouseleave", Y));
      };
    }
  }, [s, c, e, f, v, X, B, x, r, n, w, a, R, d, o, E, b]), J(() => {
    var T;
    if (c && n && (T = d.current) != null && (T = T.__options) != null && T.blockPointerEvents && _()) {
      W.current = !0;
      const S = s.floating;
      if (H(s.domReference) && S) {
        var h;
        const L = Z(s.floating).body;
        L.setAttribute(on, "");
        const Y = s.domReference, k = a == null || (h = a.nodesRef.current.find((A) => A.id === p)) == null || (h = h.context) == null ? void 0 : h.elements.floating;
        return k && (k.style.pointerEvents = ""), L.style.pointerEvents = "none", Y.style.pointerEvents = "auto", S.style.pointerEvents = "auto", () => {
          L.style.pointerEvents = "", Y.style.pointerEvents = "", S.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, p, s, a, d, _]), J(() => {
    n || (y.current = void 0, $.current = !1, B(), x());
  }, [n, B, x]), m.useEffect(() => () => {
    B(), ne(C), ne(M), x();
  }, [c, s.domReference, B, x]);
  const F = m.useMemo(() => {
    function T(h) {
      y.current = h.pointerType;
    }
    return {
      onPointerDown: T,
      onPointerEnter: T,
      onMouseMove(h) {
        const {
          nativeEvent: S
        } = h;
        function L() {
          !I.current && !w.current && r(!0, S, "hover");
        }
        f && !_e(y.current) || n || wt(b.current) === 0 || $.current && h.movementX ** 2 + h.movementY ** 2 < 2 || (ne(M), y.current === "touch" ? L() : ($.current = !0, M.current = window.setTimeout(L, wt(b.current))));
      }
    };
  }, [f, r, n, w, b]);
  return m.useMemo(() => c ? {
    reference: F
  } : {}, [c, F]);
}
let sn = 0;
function Le(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(sn);
  const i = () => e?.focus({
    preventScroll: n
  });
  o ? i() : sn = requestAnimationFrame(i);
}
function Co(e) {
  return e?.ownerDocument || document;
}
const ke = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function cn(e) {
  return e === "inert" ? ke.inert : e === "aria-hidden" ? ke["aria-hidden"] : ke.none;
}
let je = /* @__PURE__ */ new WeakSet(), Xe = {}, Rt = 0;
const To = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, jn = (e) => e && (e.host || jn(e.parentNode)), So = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = jn(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function Ao(e, t, n, r) {
  const o = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, s = So(t, e), c = /* @__PURE__ */ new Set(), u = new Set(s), l = [];
  Xe[o] || (Xe[o] = /* @__PURE__ */ new WeakMap());
  const f = Xe[o];
  s.forEach(g), v(t), c.clear();
  function g(a) {
    !a || c.has(a) || (c.add(a), a.parentNode && g(a.parentNode));
  }
  function v(a) {
    !a || u.has(a) || [].forEach.call(a.children, (p) => {
      if (Ce(p) !== "script")
        if (c.has(p))
          v(p);
        else {
          const d = i ? p.getAttribute(i) : null, R = d !== null && d !== "false", w = cn(i), b = (w.get(p) || 0) + 1, y = (f.get(p) || 0) + 1;
          w.set(p, b), f.set(p, y), l.push(p), b === 1 && R && je.add(p), y === 1 && p.setAttribute(o, ""), !R && i && p.setAttribute(i, i === "inert" ? "" : "true");
        }
    });
  }
  return Rt++, () => {
    l.forEach((a) => {
      const p = cn(i), R = (p.get(a) || 0) - 1, w = (f.get(a) || 0) - 1;
      p.set(a, R), f.set(a, w), R || (!je.has(a) && i && a.removeAttribute(i), je.delete(a)), w || a.removeAttribute(o);
    }), Rt--, Rt || (ke.inert = /* @__PURE__ */ new WeakMap(), ke["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ke.none = /* @__PURE__ */ new WeakMap(), je = /* @__PURE__ */ new WeakSet(), Xe = {});
  };
}
function ln(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = Co(e[0]).body;
  return Ao(e.concat(Array.from(r.querySelectorAll('[aria-live],[role="status"],output'))), r, t, n);
}
const ft = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, rt = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const [r, o] = m.useState();
  J(() => {
    kn() && o("button");
  }, []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Me("focus-guard")]: "",
    style: ft
  };
  return /* @__PURE__ */ ge("span", {
    ...t,
    ...i
  });
}), Xn = /* @__PURE__ */ m.createContext(null), un = /* @__PURE__ */ Me("portal");
function Oo(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = _t(), o = Un(), [i, s] = m.useState(null), c = m.useRef(null);
  return J(() => () => {
    i?.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [i]), J(() => {
    if (!r || c.current) return;
    const u = t ? document.getElementById(t) : null;
    if (!u) return;
    const l = document.createElement("div");
    l.id = r, l.setAttribute(un, ""), u.appendChild(l), c.current = l, s(l);
  }, [t, r]), J(() => {
    if (n === null || !r || c.current) return;
    let u = n || o?.portalNode;
    u && !It(u) && (u = u.current), u = u || document.body;
    let l = null;
    t && (l = document.createElement("div"), l.id = t, u.appendChild(l));
    const f = document.createElement("div");
    f.id = r, f.setAttribute(un, ""), u = l || u, u.appendChild(f), c.current = f, s(f);
  }, [t, n, r, o]), i;
}
function Yo(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, i = Oo({
    id: n,
    root: r
  }), [s, c] = m.useState(null), u = m.useRef(null), l = m.useRef(null), f = m.useRef(null), g = m.useRef(null), v = s?.modal, a = s?.open, p = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && // Don't render if unmount is transitioning.
    s.open && o && !!(r || i)
  );
  return m.useEffect(() => {
    if (!i || !o || v)
      return;
    function d(R) {
      i && Ne(R) && (R.type === "focusin" ? Yt : Fr)(i);
    }
    return i.addEventListener("focusin", d, !0), i.addEventListener("focusout", d, !0), () => {
      i.removeEventListener("focusin", d, !0), i.removeEventListener("focusout", d, !0);
    };
  }, [i, o, v]), m.useEffect(() => {
    i && (a || Yt(i));
  }, [a, i]), /* @__PURE__ */ yn(Xn.Provider, {
    value: m.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: u,
      afterOutsideRef: l,
      beforeInsideRef: f,
      afterInsideRef: g,
      portalNode: i,
      setFocusManagerState: c
    }), [o, i]),
    children: [p && i && /* @__PURE__ */ ge(rt, {
      "data-type": "outside",
      ref: u,
      onFocus: (d) => {
        if (Ne(d, i)) {
          var R;
          (R = f.current) == null || R.focus();
        } else {
          const w = s ? s.domReference : null, b = _n(w);
          b?.focus();
        }
      }
    }), p && i && /* @__PURE__ */ ge("span", {
      "aria-owns": i.id,
      style: ft
    }), i && /* @__PURE__ */ wn.createPortal(t, i), p && i && /* @__PURE__ */ ge(rt, {
      "data-type": "outside",
      ref: l,
      onFocus: (d) => {
        if (Ne(d, i)) {
          var R;
          (R = g.current) == null || R.focus();
        } else {
          const w = s ? s.domReference : null, b = Nn(w);
          b?.focus(), s?.closeOnFocusOut && s?.onOpenChange(!1, d.nativeEvent, "focus-out");
        }
      }
    })]
  });
}
const Un = () => m.useContext(Xn);
function an(e) {
  return m.useMemo(() => (t) => {
    e.forEach((n) => {
      n && (n.current = t);
    });
  }, e);
}
const Mo = 20;
let Re = [];
function $t() {
  Re = Re.filter((e) => e.isConnected);
}
function Lo(e) {
  $t(), e && Ce(e) !== "body" && (Re.push(e), Re.length > Mo && (Re = Re.slice(-20)));
}
function fn() {
  return $t(), Re[Re.length - 1];
}
function Po(e) {
  const t = Ve();
  return Pn(e, t) ? e : lt(e, t)[0] || e;
}
function dn(e, t) {
  var n;
  if (!t.current.includes("floating") && !((n = e.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const r = Ve(), i = xr(e, r).filter((c) => {
    const u = c.getAttribute("data-tabindex") || "";
    return Pn(c, r) || c.hasAttribute("data-tabindex") && !u.startsWith("-");
  }), s = e.getAttribute("tabindex");
  t.current.includes("floating") || i.length === 0 ? s !== "0" && e.setAttribute("tabindex", "0") : (s !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
const Io = /* @__PURE__ */ m.forwardRef(function(t, n) {
  return /* @__PURE__ */ ge("button", {
    ...t,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: ft
  });
});
function zo(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: s = 0,
    returnFocus: c = !0,
    restoreFocus: u = !1,
    modal: l = !0,
    visuallyHiddenDismiss: f = !1,
    closeOnFocusOut: g = !0,
    outsideElementsInert: v = !1,
    getInsideElements: a = () => []
  } = e, {
    open: p,
    onOpenChange: d,
    events: R,
    dataRef: w,
    elements: {
      domReference: b,
      floating: y
    }
  } = t, C = Q(() => {
    var P;
    return (P = w.current.floatingContext) == null ? void 0 : P.nodeId;
  }), O = Q(a), M = typeof s == "number" && s < 0, I = Xt(b) && M, W = To(), q = W ? i : !0, $ = !q || W && v, _ = Ae(o), X = Ae(s), B = Ae(c), x = at(), E = Un(), F = m.useRef(null), T = m.useRef(null), h = m.useRef(!1), S = m.useRef(!1), L = m.useRef(-1), Y = m.useRef(-1), k = E != null, A = Lt(y), ce = Q(function(P) {
    return P === void 0 && (P = A), P ? lt(P, Ve()) : [];
  }), K = Q((P) => {
    const N = ce(P);
    return _.current.map((D) => b && D === "reference" ? b : A && D === "floating" ? A : N).filter(Boolean).flat();
  });
  m.useEffect(() => {
    if (r || !l) return;
    function P(D) {
      if (D.key === "Tab") {
        G(A, we(Z(A))) && ce().length === 0 && !I && vt(D);
        const j = K(), z = de(D);
        _.current[0] === "reference" && z === b && (vt(D), D.shiftKey ? Le(j[j.length - 1]) : Le(j[1])), _.current[1] === "floating" && z === A && D.shiftKey && (vt(D), Le(j[0]));
      }
    }
    const N = Z(A);
    return N.addEventListener("keydown", P), () => {
      N.removeEventListener("keydown", P);
    };
  }, [r, b, A, l, _, I, ce, K]), m.useEffect(() => {
    if (r || !y) return;
    function P(N) {
      const D = de(N), z = ce().indexOf(D);
      z !== -1 && (L.current = z);
    }
    return y.addEventListener("focusin", P), () => {
      y.removeEventListener("focusin", P);
    };
  }, [r, y, ce]), m.useEffect(() => {
    if (r || !g) return;
    function P() {
      S.current = !0, setTimeout(() => {
        S.current = !1;
      });
    }
    function N(z) {
      const V = z.relatedTarget, ae = z.currentTarget, ie = de(z);
      queueMicrotask(() => {
        const te = C(), Te = !(G(b, V) || G(y, V) || G(V, y) || G(E?.portalNode, V) || V != null && V.hasAttribute(Me("focus-guard")) || x && (Pe(x.nodesRef.current, te).find((be) => {
          var fe, ye;
          return G((fe = be.context) == null ? void 0 : fe.elements.floating, V) || G((ye = be.context) == null ? void 0 : ye.elements.domReference, V);
        }) || Ut(x.nodesRef.current, te).find((be) => {
          var fe, ye, Bt;
          return [(fe = be.context) == null ? void 0 : fe.elements.floating, Lt((ye = be.context) == null ? void 0 : ye.elements.floating)].includes(V) || ((Bt = be.context) == null ? void 0 : Bt.elements.domReference) === V;
        })));
        if (ae === b && A && dn(A, _), u && ae !== b && !(ie != null && ie.isConnected) && we(Z(A)) === Z(A).body) {
          U(A) && A.focus();
          const be = L.current, fe = ce(), ye = fe[be] || fe[fe.length - 1] || A;
          U(ye) && ye.focus();
        }
        if (w.current.insideReactTree) {
          w.current.insideReactTree = !1;
          return;
        }
        (I || !l) && V && Te && !S.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        V !== fn() && (h.current = !0, d(!1, z, "focus-out"));
      });
    }
    const D = !!(!x && E);
    function j() {
      ne(Y), w.current.insideReactTree = !0, Y.current = window.setTimeout(() => {
        w.current.insideReactTree = !1;
      });
    }
    if (y && U(b))
      return b.addEventListener("focusout", N), b.addEventListener("pointerdown", P), y.addEventListener("focusout", N), D && y.addEventListener("focusout", j, !0), () => {
        b.removeEventListener("focusout", N), b.removeEventListener("pointerdown", P), y.removeEventListener("focusout", N), D && y.removeEventListener("focusout", j, !0);
      };
  }, [r, b, y, A, l, x, E, d, g, u, ce, I, C, _, w]);
  const oe = m.useRef(null), he = m.useRef(null), dt = an([oe, E?.beforeInsideRef]), mt = an([he, E?.afterInsideRef]);
  m.useEffect(() => {
    var P, N;
    if (r || !y) return;
    const D = Array.from((E == null || (P = E.portalNode) == null ? void 0 : P.querySelectorAll("[" + Me("portal") + "]")) || []), z = (N = (x ? Ut(x.nodesRef.current, C()) : []).find((ie) => {
      var te;
      return Xt(((te = ie.context) == null ? void 0 : te.elements.domReference) || null);
    })) == null || (N = N.context) == null ? void 0 : N.elements.domReference, V = [y, z, ...D, ...O(), F.current, T.current, oe.current, he.current, E?.beforeOutsideRef.current, E?.afterOutsideRef.current, _.current.includes("reference") || I ? b : null].filter((ie) => ie != null), ae = l || I ? ln(V, !$, $) : ln(V);
    return () => {
      ae();
    };
  }, [r, b, y, l, _, E, I, q, $, x, C, O]), J(() => {
    if (r || !U(A)) return;
    const P = Z(A), N = we(P);
    queueMicrotask(() => {
      const D = K(A), j = X.current, z = (typeof j == "number" ? D[j] : j.current) || A, V = G(A, N);
      !M && !V && p && Le(z, {
        preventScroll: z === A
      });
    });
  }, [r, p, A, M, K, X]), J(() => {
    if (r || !A) return;
    const P = Z(A), N = we(P);
    Lo(N);
    function D(V) {
      let {
        reason: ae,
        event: ie,
        nested: te
      } = V;
      if (["hover", "safe-polygon"].includes(ae) && ie.type === "mouseleave" && (h.current = !0), ae === "outside-press")
        if (te)
          h.current = !1;
        else if (Or(ie) || Mr(ie))
          h.current = !1;
        else {
          let Te = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Te = !0, !1;
            }
          }), Te ? h.current = !1 : h.current = !0;
        }
    }
    R.on("openchange", D);
    const j = P.createElement("span");
    j.setAttribute("tabindex", "-1"), j.setAttribute("aria-hidden", "true"), Object.assign(j.style, ft), k && b && b.insertAdjacentElement("afterend", j);
    function z() {
      if (typeof B.current == "boolean") {
        const V = b || fn();
        return V && V.isConnected ? V : j;
      }
      return B.current.current || j;
    }
    return () => {
      R.off("openchange", D);
      const V = we(P), ae = G(y, V) || x && Pe(x.nodesRef.current, C(), !1).some((te) => {
        var Te;
        return G((Te = te.context) == null ? void 0 : Te.elements.floating, V);
      }), ie = z();
      queueMicrotask(() => {
        const te = Po(ie);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        B.current && !h.current && U(te) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(te !== V && V !== P.body) || ae) && te.focus({
          preventScroll: !0
        }), j.remove();
      });
    };
  }, [r, y, A, B, w, R, x, k, b, C]), m.useEffect(() => (queueMicrotask(() => {
    h.current = !1;
  }), () => {
    queueMicrotask($t);
  }), [r]), J(() => {
    if (!r && E)
      return E.setFocusManagerState({
        modal: l,
        closeOnFocusOut: g,
        open: p,
        onOpenChange: d,
        domReference: b
      }), () => {
        E.setFocusManagerState(null);
      };
  }, [r, E, l, p, d, g, b]), J(() => {
    r || A && dn(A, _);
  }, [r, A, _]);
  function He(P) {
    return r || !f || !l ? null : /* @__PURE__ */ ge(Io, {
      ref: P === "start" ? F : T,
      onClick: (N) => d(!1, N.nativeEvent),
      children: typeof f == "string" ? f : "Dismiss"
    });
  }
  const Ke = !r && q && (l ? !I : !0) && (k || l);
  return /* @__PURE__ */ yn(Yn, {
    children: [Ke && /* @__PURE__ */ ge(rt, {
      "data-type": "inside",
      ref: dt,
      onFocus: (P) => {
        if (l) {
          const D = K();
          Le(o[0] === "reference" ? D[0] : D[D.length - 1]);
        } else if (E != null && E.preserveTabOrder && E.portalNode)
          if (h.current = !1, Ne(P, E.portalNode)) {
            const D = Nn(b);
            D?.focus();
          } else {
            var N;
            (N = E.beforeOutsideRef.current) == null || N.focus();
          }
      }
    }), !I && He("start"), n, He("end"), Ke && /* @__PURE__ */ ge(rt, {
      "data-type": "inside",
      ref: mt,
      onFocus: (P) => {
        if (l)
          Le(K()[0]);
        else if (E != null && E.preserveTabOrder && E.portalNode)
          if (g && (h.current = !0), Ne(P, E.portalNode)) {
            const D = _n(b);
            D?.focus();
          } else {
            var N;
            (N = E.afterOutsideRef.current) == null || N.focus();
          }
      }
    })]
  });
}
let Ue = 0;
const mn = "--floating-ui-scrollbar-width";
function ko() {
  const e = Dt(), t = /iP(hone|ad|od)|iOS/.test(e) || // iPads can claim to be MacIntel
  e === "MacIntel" && navigator.maxTouchPoints > 1, n = document.body.style, o = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", i = window.innerWidth - document.documentElement.clientWidth, s = n.left ? parseFloat(n.left) : window.scrollX, c = n.top ? parseFloat(n.top) : window.scrollY;
  if (n.overflow = "hidden", n.setProperty(mn, i + "px"), i && (n[o] = i + "px"), t) {
    var u, l;
    const f = ((u = window.visualViewport) == null ? void 0 : u.offsetLeft) || 0, g = ((l = window.visualViewport) == null ? void 0 : l.offsetTop) || 0;
    Object.assign(n, {
      position: "fixed",
      top: -(c - Math.floor(g)) + "px",
      left: -(s - Math.floor(f)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(n, {
      overflow: "",
      [o]: ""
    }), n.removeProperty(mn), t && (Object.assign(n, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(s, c));
  };
}
let gn = () => {
};
const Go = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    lockScroll: r = !1,
    ...o
  } = t;
  return J(() => {
    if (r)
      return Ue++, Ue === 1 && (gn = ko()), () => {
        Ue--, Ue === 0 && gn();
      };
  }, [r]), /* @__PURE__ */ ge("div", {
    ref: n,
    ...o,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...o.style
    }
  });
});
function pn(e) {
  return U(e.target) && e.target.tagName === "BUTTON";
}
function Do(e) {
  return U(e.target) && e.target.tagName === "A";
}
function vn(e) {
  return Ft(e);
}
function Zo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: s = !0,
    event: c = "click",
    toggle: u = !0,
    ignoreMouse: l = !1,
    keyboardHandlers: f = !0,
    stickIfOpen: g = !0
  } = t, v = m.useRef(), a = m.useRef(!1), p = m.useMemo(() => ({
    onPointerDown(d) {
      v.current = d.pointerType;
    },
    onMouseDown(d) {
      const R = v.current;
      d.button === 0 && c !== "click" && (_e(R, !0) && l || (n && u && (!(o.current.openEvent && g) || o.current.openEvent.type === "mousedown") ? r(!1, d.nativeEvent, "click") : (d.preventDefault(), r(!0, d.nativeEvent, "click"))));
    },
    onClick(d) {
      const R = v.current;
      if (c === "mousedown" && v.current) {
        v.current = void 0;
        return;
      }
      _e(R, !0) && l || (n && u && (!(o.current.openEvent && g) || o.current.openEvent.type === "click") ? r(!1, d.nativeEvent, "click") : r(!0, d.nativeEvent, "click"));
    },
    onKeyDown(d) {
      v.current = void 0, !(d.defaultPrevented || !f || pn(d)) && (d.key === " " && !vn(i) && (d.preventDefault(), a.current = !0), !Do(d) && d.key === "Enter" && r(!(n && u), d.nativeEvent, "click"));
    },
    onKeyUp(d) {
      d.defaultPrevented || !f || pn(d) || vn(i) || d.key === " " && a.current && (a.current = !1, r(!(n && u), d.nativeEvent, "click"));
    }
  }), [o, i, c, l, f, r, n, g, u]);
  return m.useMemo(() => s ? {
    reference: p
  } : {}, [s, p]);
}
const Fo = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, No = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, hn = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function Jo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: s = !0,
    escapeKey: c = !0,
    outsidePress: u = !0,
    outsidePressEvent: l = "pointerdown",
    referencePress: f = !1,
    referencePressEvent: g = "pointerdown",
    ancestorScroll: v = !1,
    bubbles: a,
    capture: p
  } = t, d = at(), R = Q(typeof u == "function" ? u : () => !1), w = typeof u == "function" ? R : u, b = m.useRef(!1), {
    escapeKey: y,
    outsidePress: C
  } = hn(a), {
    escapeKey: O,
    outsidePress: M
  } = hn(p), I = m.useRef(!1), W = Q((x) => {
    var E;
    if (!n || !s || !c || x.key !== "Escape" || I.current)
      return;
    const F = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, T = d ? Pe(d.nodesRef.current, F) : [];
    if (!y && (x.stopPropagation(), T.length > 0)) {
      let h = !0;
      if (T.forEach((S) => {
        var L;
        if ((L = S.context) != null && L.open && !S.context.dataRef.current.__escapeKeyBubbles) {
          h = !1;
          return;
        }
      }), !h)
        return;
    }
    r(!1, Ar(x) ? x.nativeEvent : x, "escape-key");
  }), q = Q((x) => {
    var E;
    const F = () => {
      var T;
      W(x), (T = de(x)) == null || T.removeEventListener("keydown", F);
    };
    (E = de(x)) == null || E.addEventListener("keydown", F);
  }), $ = Q((x) => {
    var E;
    const F = i.current.insideReactTree;
    i.current.insideReactTree = !1;
    const T = b.current;
    if (b.current = !1, l === "click" && T || F || typeof w == "function" && !w(x))
      return;
    const h = de(x), S = "[" + Me("inert") + "]", L = Z(o.floating).querySelectorAll(S);
    let Y = H(h) ? h : null;
    for (; Y && !pe(Y); ) {
      const K = ve(Y);
      if (pe(K) || !H(K))
        break;
      Y = K;
    }
    if (L.length && H(h) && !Tr(h) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !G(h, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(L).every((K) => !G(Y, K)))
      return;
    if (U(h) && B) {
      const K = pe(h), oe = se(h), he = /auto|scroll/, dt = K || he.test(oe.overflowX), mt = K || he.test(oe.overflowY), He = dt && h.clientWidth > 0 && h.scrollWidth > h.clientWidth, Ke = mt && h.clientHeight > 0 && h.scrollHeight > h.clientHeight, P = oe.direction === "rtl", N = Ke && (P ? x.offsetX <= h.offsetWidth - h.clientWidth : x.offsetX > h.clientWidth), D = He && x.offsetY > h.clientHeight;
      if (N || D)
        return;
    }
    const k = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, A = d && Pe(d.nodesRef.current, k).some((K) => {
      var oe;
      return pt(x, (oe = K.context) == null ? void 0 : oe.elements.floating);
    });
    if (pt(x, o.floating) || pt(x, o.domReference) || A)
      return;
    const ce = d ? Pe(d.nodesRef.current, k) : [];
    if (ce.length > 0) {
      let K = !0;
      if (ce.forEach((oe) => {
        var he;
        if ((he = oe.context) != null && he.open && !oe.context.dataRef.current.__outsidePressBubbles) {
          K = !1;
          return;
        }
      }), !K)
        return;
    }
    r(!1, x, "outside-press");
  }), _ = Q((x) => {
    var E;
    const F = () => {
      var T;
      $(x), (T = de(x)) == null || T.removeEventListener(l, F);
    };
    (E = de(x)) == null || E.addEventListener(l, F);
  });
  m.useEffect(() => {
    if (!n || !s)
      return;
    i.current.__escapeKeyBubbles = y, i.current.__outsidePressBubbles = C;
    let x = -1;
    function E(L) {
      r(!1, L, "ancestor-scroll");
    }
    function F() {
      window.clearTimeout(x), I.current = !0;
    }
    function T() {
      x = window.setTimeout(
        () => {
          I.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        st() ? 5 : 0
      );
    }
    const h = Z(o.floating);
    c && (h.addEventListener("keydown", O ? q : W, O), h.addEventListener("compositionstart", F), h.addEventListener("compositionend", T)), w && h.addEventListener(l, M ? _ : $, M);
    let S = [];
    return v && (H(o.domReference) && (S = xe(o.domReference)), H(o.floating) && (S = S.concat(xe(o.floating))), !H(o.reference) && o.reference && o.reference.contextElement && (S = S.concat(xe(o.reference.contextElement)))), S = S.filter((L) => {
      var Y;
      return L !== ((Y = h.defaultView) == null ? void 0 : Y.visualViewport);
    }), S.forEach((L) => {
      L.addEventListener("scroll", E, {
        passive: !0
      });
    }), () => {
      c && (h.removeEventListener("keydown", O ? q : W, O), h.removeEventListener("compositionstart", F), h.removeEventListener("compositionend", T)), w && h.removeEventListener(l, M ? _ : $, M), S.forEach((L) => {
        L.removeEventListener("scroll", E);
      }), window.clearTimeout(x);
    };
  }, [i, o, c, w, l, n, r, v, s, y, C, W, O, q, $, M, _]), m.useEffect(() => {
    i.current.insideReactTree = !1;
  }, [i, w, l]);
  const X = m.useMemo(() => ({
    onKeyDown: W,
    ...f && {
      [Fo[g]]: (x) => {
        r(!1, x.nativeEvent, "reference-press");
      },
      ...g !== "click" && {
        onClick(x) {
          r(!1, x.nativeEvent, "reference-press");
        }
      }
    }
  }), [W, r, f, g]), B = m.useMemo(() => ({
    onKeyDown: W,
    onMouseDown() {
      b.current = !0;
    },
    onMouseUp() {
      b.current = !0;
    },
    [No[l]]: () => {
      i.current.insideReactTree = !0;
    }
  }), [W, l, i]);
  return m.useMemo(() => s ? {
    reference: X,
    floating: B
  } : {}, [s, X, B]);
}
function _o(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = _t(), i = m.useRef({}), [s] = m.useState(() => Ro()), c = Wt() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = r.reference;
    a && !H(a) && wo("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [u, l] = m.useState(r.reference), f = Q((a, p, d) => {
    i.current.openEvent = a ? p : void 0, s.emit("openchange", {
      open: a,
      event: p,
      reason: d,
      nested: c
    }), n?.(a, p, d);
  }), g = m.useMemo(() => ({
    setPositionReference: l
  }), []), v = m.useMemo(() => ({
    reference: u || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [u, r.reference, r.floating]);
  return m.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: f,
    elements: v,
    events: s,
    floatingId: o,
    refs: g
  }), [t, f, v, s, o, g]);
}
function Qo(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = _o({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, s] = m.useState(null), [c, u] = m.useState(null), f = o?.domReference || i, g = m.useRef(null), v = at();
  J(() => {
    f && (g.current = f);
  }, [f]);
  const a = go({
    ...e,
    elements: {
      ...o,
      ...c && {
        reference: c
      }
    }
  }), p = m.useCallback((y) => {
    const C = H(y) ? {
      getBoundingClientRect: () => y.getBoundingClientRect(),
      getClientRects: () => y.getClientRects(),
      contextElement: y
    } : y;
    u(C), a.refs.setReference(C);
  }, [a.refs]), d = m.useCallback((y) => {
    (H(y) || y === null) && (g.current = y, s(y)), (H(a.refs.reference.current) || a.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    y !== null && !H(y)) && a.refs.setReference(y);
  }, [a.refs]), R = m.useMemo(() => ({
    ...a.refs,
    setReference: d,
    setPositionReference: p,
    domReference: g
  }), [a.refs, d, p]), w = m.useMemo(() => ({
    ...a.elements,
    domReference: f
  }), [a.elements, f]), b = m.useMemo(() => ({
    ...a,
    ...r,
    refs: R,
    elements: w,
    nodeId: t
  }), [a, R, w, t, r]);
  return J(() => {
    r.dataRef.current.floatingContext = b;
    const y = v?.nodesRef.current.find((C) => C.id === t);
    y && (y.context = b);
  }), m.useMemo(() => ({
    ...a,
    context: b,
    refs: R,
    elements: w
  }), [a, R, w, b]);
}
function xt() {
  return Er() && kn();
}
function ei(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: s
  } = e, {
    enabled: c = !0,
    visibleOnly: u = !0
  } = t, l = m.useRef(!1), f = m.useRef(-1), g = m.useRef(!0);
  m.useEffect(() => {
    if (!c) return;
    const a = ee(s.domReference);
    function p() {
      !n && U(s.domReference) && s.domReference === we(Z(s.domReference)) && (l.current = !0);
    }
    function d() {
      g.current = !0;
    }
    function R() {
      g.current = !1;
    }
    return a.addEventListener("blur", p), xt() && (a.addEventListener("keydown", d, !0), a.addEventListener("pointerdown", R, !0)), () => {
      a.removeEventListener("blur", p), xt() && (a.removeEventListener("keydown", d, !0), a.removeEventListener("pointerdown", R, !0));
    };
  }, [s.domReference, n, c]), m.useEffect(() => {
    if (!c) return;
    function a(p) {
      let {
        reason: d
      } = p;
      (d === "reference-press" || d === "escape-key") && (l.current = !0);
    }
    return o.on("openchange", a), () => {
      o.off("openchange", a);
    };
  }, [o, c]), m.useEffect(() => () => {
    ne(f);
  }, []);
  const v = m.useMemo(() => ({
    onMouseLeave() {
      l.current = !1;
    },
    onFocus(a) {
      if (l.current) return;
      const p = de(a.nativeEvent);
      if (u && H(p)) {
        if (xt() && !a.relatedTarget) {
          if (!g.current && !Ft(p))
            return;
        } else if (!Sr(p))
          return;
      }
      r(!0, a.nativeEvent, "focus");
    },
    onBlur(a) {
      l.current = !1;
      const p = a.relatedTarget, d = a.nativeEvent, R = H(p) && p.hasAttribute(Me("focus-guard")) && p.getAttribute("data-type") === "outside";
      f.current = window.setTimeout(() => {
        var w;
        const b = we(s.domReference ? s.domReference.ownerDocument : document);
        !p && b === s.domReference || G((w = i.current.floatingContext) == null ? void 0 : w.refs.floating.current, b) || G(s.domReference, b) || R || r(!1, d, "focus");
      });
    }
  }), [i, s.domReference, r, u]);
  return m.useMemo(() => c ? {
    reference: v
  } : {}, [c, v]);
}
function Et(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [en]: s,
      [tn]: c,
      ...u
    } = e;
    i = u;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [po]: ""
    },
    ...i,
    ...t.map((s) => {
      const c = s ? s[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((s, c) => (c && Object.entries(c).forEach((u) => {
      let [l, f] = u;
      if (!(o && [en, tn].includes(l)))
        if (l.indexOf("on") === 0) {
          if (r.has(l) || r.set(l, []), typeof f == "function") {
            var g;
            (g = r.get(l)) == null || g.push(f), s[l] = function() {
              for (var v, a = arguments.length, p = new Array(a), d = 0; d < a; d++)
                p[d] = arguments[d];
              return (v = r.get(l)) == null ? void 0 : v.map((R) => R(...p)).find((R) => R !== void 0);
            };
          }
        } else
          s[l] = f;
    }), s), {})
  };
}
function ti(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c?.reference), n = e.map((c) => c?.floating), r = e.map((c) => c?.item), o = m.useCallback(
    (c) => Et(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = m.useCallback(
    (c) => Et(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), s = m.useCallback(
    (c) => Et(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return m.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: s
  }), [o, i, s]);
}
const Wo = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function ni(e, t) {
  var n, r;
  t === void 0 && (t = {});
  const {
    open: o,
    elements: i,
    floatingId: s
  } = e, {
    enabled: c = !0,
    role: u = "dialog"
  } = t, l = _t(), f = ((n = i.domReference) == null ? void 0 : n.id) || l, g = m.useMemo(() => {
    var b;
    return ((b = Lt(i.floating)) == null ? void 0 : b.id) || s;
  }, [i.floating, s]), v = (r = Wo.get(u)) != null ? r : u, p = Wt() != null, d = m.useMemo(() => v === "tooltip" || u === "label" ? {
    ["aria-" + (u === "label" ? "labelledby" : "describedby")]: o ? g : void 0
  } : {
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": v === "alertdialog" ? "dialog" : v,
    "aria-controls": o ? g : void 0,
    ...v === "listbox" && {
      role: "combobox"
    },
    ...v === "menu" && {
      id: f
    },
    ...v === "menu" && p && {
      role: "menuitem"
    },
    ...u === "select" && {
      "aria-autocomplete": "none"
    },
    ...u === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [v, g, p, o, f, u]), R = m.useMemo(() => {
    const b = {
      id: g,
      ...v && {
        role: v
      }
    };
    return v === "tooltip" || u === "label" ? b : {
      ...b,
      ...v === "menu" && {
        "aria-labelledby": f
      }
    };
  }, [v, g, f, u]), w = m.useCallback((b) => {
    let {
      active: y,
      selected: C
    } = b;
    const O = {
      role: "option",
      ...y && {
        id: g + "-fui-option"
      }
    };
    switch (u) {
      case "select":
      case "combobox":
        return {
          ...O,
          "aria-selected": C
        };
    }
    return {};
  }, [g, u]);
  return m.useMemo(() => c ? {
    reference: d,
    floating: R,
    item: w
  } : {}, [c, d, R, w]);
}
export {
  Yo as F,
  Qo as a,
  Jo as b,
  ni as c,
  ti as d,
  Go as e,
  zo as f,
  Zo as g,
  Uo as h,
  ei as i,
  Vo as j,
  qo as k,
  jo as l,
  Ho as o,
  Ko as s,
  Xo as u
};
